import React from "react";
import { _goToCustomer } from "routers/helper";

import { View, StyleSheet, TouchableOpacity } from "react-native";

import Img from "components/img";
import Text from "components/Text";
import Icon from "components/Icon";
import Switch from "components/Switch";

import { sizes, colors } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";

import { useChangeWholesalerStatus } from "clients/apis";
import { alertPermission, sn } from "utils";
import { useChmod } from "hooks";

export default function WholesalerBox(props: { wholesaler: WholesalerT }) {
  const { chmod } = useChmod();

  const {
    company: { color },
  } = useRecoilValue(authAtom);
  const { wholesaler } = props;

  const isCustomer = wholesaler?.customer?.id;

  const _onEnable = useChangeWholesalerStatus(wholesaler.id, "enable");
  const _onDisable = useChangeWholesalerStatus(wholesaler.id, "disable");

  const _onChangeStatus = (status: 0 | 1) =>
    status === 1 ? _onEnable.mutate() : _onDisable.mutate();

  const _goToCustomerDetails = () =>
    _goToCustomer({ data: wholesaler.customer });

  return (
    <View style={styles.container}>
      <View style={styles.box}>
        <View style={styles.header}>
          <View style={styles.avatarContainer}>
            <Icon name="user" color={"#e1e1e1"} size={30} />
            {wholesaler?.avatar && (
              <Img source={{ uri: wholesaler?.avatar }} style={styles.avatar} />
            )}
          </View>
          <View style={styles.titleContainer}>
            <View>
              <Text size={"lg"} weight="bold">
                {wholesaler?.name}
              </Text>
              <Text
                style={{ marginTop: sn(2, 4, 10, 10) }}
                size={"xs"}
                weight="black"
              >
                {wholesaler?.mobile}
              </Text>
            </View>

            <Text size={"xs"} weight="extraBold">
              {wholesaler.store_name}
            </Text>
          </View>
        </View>
        <View style={styles.addressContainer}>
          <Icon style={{ top: 3 }} size={15} name="map-pin" />
          <Text size={"sm"} weight="bold">
            {" "}
            {wholesaler.province.text}
          </Text>
          <Text size={"sm"} weight="bold">
            {" "}
            - {wholesaler.city.text}
          </Text>
          {wholesaler.Address && (
            <Text size={"sm"}> - {wholesaler.Address}</Text>
          )}
        </View>

        <View style={styles.footer}>
          <Switch
            onChange={
              chmod("wholesalers", "PUT") ? _onChangeStatus : alertPermission
            }
            value={wholesaler.status}
            activeLabel="فعال"
            inactiveLabel="فعال"
          />
          <View style={styles.code}>
            <Text weight="extraBold" size={"xs"}>
              کد بنکداری{" "}
            </Text>
            <Text color={color} lang="en" size={"sm"} weight="black">
              {wholesaler.code}
            </Text>
          </View>
        </View>
      </View>
      <TouchableOpacity
        onPress={_goToCustomerDetails}
        activeOpacity={sizes.tapOpacity}
        style={styles.customerLink}
      >
        <View style={styles.customerName}>
          <View style={{ top: 2 }}>
            <Text
              color={isCustomer ? colors.info : colors.textColorGray}
              weight="bold"
              size={"sm"}
            >
              {" "}
              {isCustomer
                ? "مشاهده اطلاعات مشتری"
                : "بنکدار در لیست مشتریان وجود ندارد"}{" "}
            </Text>
          </View>
        </View>

        {isCustomer && <Icon name="chevron-left" color={colors.info} />}
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    overflow: "hidden",
    borderWidth: 2,
    borderColor: colors.white,
    borderRadius: sizes.radius.md,
    backgroundColor: colors.itemsBg,
  },

  box: {
    paddingVertical: 5,
    paddingHorizontal: 10,
  },

  header: {
    flexDirection: "row-reverse",
    justifyContent: "space-between",
  },

  avatarContainer: {
    width: 60,
    aspectRatio: 1,
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 10,
    borderWidth: 1,
    borderRadius: 60,
    borderColor: colors.lightBorder,
    backgroundColor: colors.lightButtons,
  },

  avatar: {
    width: "100%",
    height: "100%",
    position: "absolute",
    borderRadius: 60,
  },

  titleContainer: {
    flex: 1,
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    marginTop: 5,
  },

  addressContainer: {
    flexDirection: "row-reverse",
    marginTop: 5,
    marginBottom: 12,
    top: -2,
  },

  footer: { flexDirection: "row-reverse", justifyContent: "space-between" },

  code: {
    flexDirection: "row-reverse",
    alignItems: "center",
    backgroundColor: colors.lightButtons,
    paddingHorizontal: 5,
    right: -5,
    borderRadius: sizes.radius.sm,
  },

  customerLink: {
    height: 50,
    alignItems: "center",
    paddingLeft: 7,
    backgroundColor: colors.innerItemsBg,
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    top: 5,
    paddingBottom: 5,
  },

  customerName: { flexDirection: "row-reverse", alignItems: "center" },
});
